import { ApexOptions } from 'apexcharts';

export const analyticsChartTheme: ApexOptions = {
  chart: {
    background: 'transparent',
    toolbar: {
      show: true,
      tools: {
        download: true,
        zoom: true,
        zoomin: true,
        zoomout: true,
        pan: true,
        reset: true
      }
    },
    animations: {
      enabled: true,
      speed: 800,
      animateGradually: {
        enabled: true,
        delay: 150
      },
      dynamicAnimation: {
        enabled: true,
        speed: 350
      }
    }
  },
  colors: ['#00d4ff', '#4CAF50', '#FF9800', '#f44336', '#9C27B0'],
  theme: {
    mode: 'dark'
  },
  grid: {
    borderColor: 'rgba(0, 212, 255, 0.15)',
    strokeDashArray: 4,
    xaxis: {
      lines: {
        show: false
      }
    },
    yaxis: {
      lines: {
        show: true
      }
    }
  },
  xaxis: {
    labels: {
      style: {
        colors: '#ffffff',
        fontFamily: "'Courier New', monospace",
        fontSize: '12px',
        fontWeight: 'bold'
      }
    },
    axisBorder: {
      color: 'rgba(0, 212, 255, 0.3)'
    },
    axisTicks: {
      color: 'rgba(0, 212, 255, 0.3)'
    }
  },
  yaxis: {
    labels: {
      style: {
        colors: '#ffffff',
        fontFamily: "'Courier New', monospace",
        fontSize: '12px',
        fontWeight: 'bold'
      }
    }
  },
  tooltip: {
    theme: 'dark',
    style: {
      fontFamily: "'Courier New', monospace"
    },
    x: {
      show: true
    }
  },
  legend: {
    labels: {
      colors: '#ffffff'
    },
    fontFamily: "'Courier New', monospace",
    fontSize: '12px',
    fontWeight: 700
  },
  dataLabels: {
    style: {
      fontFamily: "'Courier New', monospace",
      fontWeight: 'bold'
    }
  },
  stroke: {
    curve: 'smooth',
    width: 2
  },
  fill: {
    opacity: 1
  }
};

export const areaChartOptions: ApexOptions = {
  ...analyticsChartTheme,
  chart: {
    ...analyticsChartTheme.chart,
    type: 'area',
    stacked: true
  },
  fill: {
    type: 'gradient',
    gradient: {
      shadeIntensity: 1,
      opacityFrom: 0.7,
      opacityTo: 0.2,
      stops: [0, 90, 100]
    }
  }
};

export const barChartOptions: ApexOptions = {
  ...analyticsChartTheme,
  chart: {
    ...analyticsChartTheme.chart,
    type: 'bar'
  },
  plotOptions: {
    bar: {
      borderRadius: 4,
      horizontal: false,
      columnWidth: '60%'
    }
  }
};

export const horizontalBarChartOptions: ApexOptions = {
  ...analyticsChartTheme,
  chart: {
    ...analyticsChartTheme.chart,
    type: 'bar'
  },
  plotOptions: {
    bar: {
      borderRadius: 4,
      horizontal: true,
      barHeight: '70%'
    }
  }
};

export const donutChartOptions: ApexOptions = {
  ...analyticsChartTheme,
  chart: {
    ...analyticsChartTheme.chart,
    type: 'donut'
  },
  plotOptions: {
    pie: {
      donut: {
        size: '65%',
        labels: {
          show: true,
          name: {
            show: true,
            fontSize: '14px',
            fontFamily: "'Rajdhani', sans-serif",
            fontWeight: 700,
            color: '#ffffff'
          },
          value: {
            show: true,
            fontSize: '24px',
            fontFamily: "'Rajdhani', sans-serif",
            fontWeight: 700,
            color: '#00d4ff',
            formatter: (val: string) => val
          },
          total: {
            show: true,
            label: 'Total',
            fontSize: '14px',
            fontFamily: "'Rajdhani', sans-serif",
            fontWeight: 700,
            color: '#ffffff'
          }
        }
      }
    }
  },
  stroke: {
    show: false
  }
};

export const radialBarChartOptions: ApexOptions = {
  ...analyticsChartTheme,
  chart: {
    ...analyticsChartTheme.chart,
    type: 'radialBar'
  },
  plotOptions: {
    radialBar: {
      hollow: {
        size: '50%'
      },
      track: {
        background: 'rgba(0, 212, 255, 0.1)'
      },
      dataLabels: {
        name: {
          fontSize: '14px',
          fontFamily: "'Rajdhani', sans-serif",
          fontWeight: 700,
          color: '#ffffff'
        },
        value: {
          fontSize: '24px',
          fontFamily: "'Rajdhani', sans-serif",
          fontWeight: 700,
          color: '#00d4ff',
          formatter: (val: number) => `${val}%`
        }
      }
    }
  }
};

export const lineChartOptions: ApexOptions = {
  ...analyticsChartTheme,
  chart: {
    ...analyticsChartTheme.chart,
    type: 'line'
  },
  stroke: {
    curve: 'smooth',
    width: 3
  },
  markers: {
    size: 4,
    colors: ['#00d4ff'],
    strokeColors: '#fff',
    strokeWidth: 2
  }
};
